import React, { useState, useEffect } from 'react';
import RoundDetailsWindow from './RoundDetailsWindow';
import TableViewComponent from './TableViewComponent';
import ErrorPage from '../pages/ErrorPage';
import Loading from './Loader';
import '../assets/css/style.css';
import queryString from 'query-string';

const MainComponent = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tableData, setTableData] = useState(null);
  const [htmlData, setHtmlData] = useState(null);
  const [url, setURL] = useState(null);
  const [providerName, setProviderName] = useState(null);
  const launchData = queryString.parse(window.location.search);

   useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;
  
    const launch = async () => {
      try {
        if (!launchData.url) {
          setError("Missing launch data.");
          setLoading(false);
          return;
        }
  
        const decoded = decodeURIComponent(launchData.url);
        const parsedUrlObj = JSON.parse(decoded);
        const dataType = parsedUrlObj.type;
        const data = parsedUrlObj.data;
  
        const provider_name = launchData?.provider_name || null;
        setProviderName(provider_name);
  
        if (dataType === 'url') {
          setURL(data);
          if (provider_name === "Ezugi" || 
            provider_name === "Nolimit City" || 
            provider_name === "Nolimit City - 94" || 
            provider_name === "Nolimit City - 96" || 
            provider_name === "NetEnt" || 
            provider_name === "Red Tiger" || 
            provider_name === "Tap-A-Roo" ||
            provider_name === "Big Time Gaming") {
            window.open(data, "_blank");
          }
          setLoading(false);
        } else if (dataType === 'html') {
          const queryParams = new URLSearchParams({
            player_code: data.player_code,
            game_id: data.game_id,
            round_id: data.round_id,
          }).toString();
  
          const fullUrl = `${data.round_url}?${queryParams}`;
  
          const res = await fetch(fullUrl, { signal });
          if (!res.ok) throw new Error('Failed to fetch HTML content');
          const htmlContent = await res.text();
          const htmlObj = JSON.parse(htmlContent);
          console.log('htmlObj>>>>>>>', htmlObj);
          if (htmlObj?.code == '1000') {
            console.log('data>>>>>', htmlObj?.data?.data);
            setHtmlData(htmlObj?.data?.data);
            setError(null); // <-- Clear any previous error
          } else {
            console.log('error>>>>>', htmlObj?.code);
            setError(`CODE : ${htmlObj.code} - Message: ${htmlObj.message}`);
          }
          setLoading(false);
        } else {
          setTableData([data]);
          setLoading(false);
        }
      } catch (err) {
        if (err.name !== 'AbortError') {
          setError("Failed to launch game result.");
          setLoading(false);
        }
      }
    };
  
    launch();
  
    return () => {
      controller.abort(); // Cancel on cleanup
    };
  }, []);
  

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return <ErrorPage errorMessage={error} />;
  }
  const excludedProviders = [
    "Ezugi",
    "Nolimit City",
    "Nolimit City - 94",
    "Nolimit City - 96",
    "NetEnt",
    "Red Tiger",
    "Big Time Gaming",
    "Tap-A-Roo"
  ];
  return (
    <div>
      {url && !excludedProviders.includes(providerName) && <RoundDetailsWindow url={url} />}
      {tableData && <TableViewComponent data={tableData} />}
      {/* {htmlData && (
        <div
          className="html-view"
          dangerouslySetInnerHTML={{ __html: htmlData }}
        />
      )} */}


    {htmlData && (
      <iframe
        title="Game HTML"
        srcDoc={htmlData}
        style={{ width: '100%', height: '100vh', border: 'none' }}
      />
    )}
    </div>
  );
};

export default MainComponent;
